export enum TipoFiltroEnum
{
  Input = 1,
  MultiSelect,
  DropDown,
  DropDownMulti,
  Fecha,
  RangoFecha
}
